import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=63bc30f3&scoped=true&"
import script from "./Init.vue?vue&type=script&lang=js&"
export * from "./Init.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc30f3",
  null
  
)

export default component.exports